import { render, staticRenderFns } from "./DetailManagement.vue?vue&type=template&id=0942bcf4&scoped=true&"
import script from "./DetailManagement.vue?vue&type=script&lang=ts&"
export * from "./DetailManagement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0942bcf4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0942bcf4')) {
      api.createRecord('0942bcf4', component.options)
    } else {
      api.reload('0942bcf4', component.options)
    }
    module.hot.accept("./DetailManagement.vue?vue&type=template&id=0942bcf4&scoped=true&", function () {
      api.rerender('0942bcf4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/rooms/DetailManagement.vue"
export default component.exports